import { render, staticRenderFns } from "./WebsiteMigrationsList.vue?vue&type=template&id=10733ab8&"
import script from "./WebsiteMigrationsList.vue?vue&type=script&lang=ts&"
export * from "./WebsiteMigrationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports